/**
 * Auth helpers — token management and OAuth flow.
 * @spec SPEC:ENGINEERING:FRONTEND:AUTH
 */
import { api } from './api'

const API_BASE = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3000'

export function getGitHubLoginUrl(inviteCode?: string): string {
  const url = new URL(`${API_BASE}/v1/auth/github`)
  if (inviteCode) {
    url.searchParams.set('invite', inviteCode)
  }
  return url.toString()
}

export function getGoogleLoginUrl(inviteCode?: string): string {
  const url = new URL(`${API_BASE}/v1/auth/google`)
  if (inviteCode) {
    url.searchParams.set('invite', inviteCode)
  }
  return url.toString()
}

export async function exchangeCode(code: string): Promise<{ token: string; refreshToken: string; isNewUser?: boolean }> {
  const result = await api.post<{ token: string; refreshToken: string; isNewUser?: boolean }>('/auth/exchange', { code })
  api.setToken(result.token)
  return result
}

export async function refreshAccessToken(): Promise<void> {
  const refreshToken = localStorage.getItem('refresh_token')
  if (!refreshToken) throw new Error('No refresh token')
  const result = await api.post<{ token: string; refreshToken: string }>('/auth/refresh', { refreshToken })
  api.setToken(result.token)
  localStorage.setItem('refresh_token', result.refreshToken)
}

export function clearAuth(): void {
  api.setToken(null)
  localStorage.removeItem('refresh_token')
}
